export default __webpack_public_path__ + "static/media/arrow.bf228669.svg";